import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config/env';

const supabaseRequest = async (endpoint, options = {}) => {
  const response = await fetch(`${SUPABASE_URL}${endpoint}`, {
    ...options,
    headers: {
      'apikey': SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(error.message || 'Request failed');
  }
  return response.json();
};

export class SupervisorService {
  static async getOperationsData() {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/supervisor_get_operations_data`, {
        method: 'POST',
        body: JSON.stringify({}),
      });
      return { success: true, data: (Array.isArray(data) ? data[0] : data) || {}, error: null };
    } catch (error) {
      console.error('Error fetching operations data:', error);
      return { success: false, data: {}, error: error.message };
    }
  }

  static async getReports(filters) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/supervisor_get_reports`, {
        method: 'POST',
        body: JSON.stringify(filters || {}),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching reports:', error);
      return { success: false, data: [], error: error.message };
    }
  }
}

